import { ColumnDataProps } from '../components/props/tables';

const columns: ColumnDataProps[] = [
  {
    dataKey: 'name',
    label: 'Name',
    width: 340,
  },
  {
    dataKey: 'memberIds',
    label: 'Members',
    width: 100,
    numeric: true,
    amount: true,
  },
  {
    dataKey: 'formIds',
    label: 'Apps',
    width: 100,
    numeric: true,
    amount: true,
  },
  {
    dataKey: 'layerIds',
    label: 'Map Layers',
    width: 100,
    numeric: true,
    amount: true,
  },
  {
    dataKey: 'projectIds',
    label: 'Projects',
    width: 100,
    numeric: true,
    amount: true,
  },
];

export default columns;
